import { render, staticRenderFns } from "./RecordManagement.vue?vue&type=template&id=319a8e1f&scoped=true&"
import script from "./RecordManagement.vue?vue&type=script&lang=js&"
export * from "./RecordManagement.vue?vue&type=script&lang=js&"
import style0 from "./RecordManagement.vue?vue&type=style&index=0&id=319a8e1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a8e1f",
  null
  
)

export default component.exports